module.exports = __webpack_public_path__ + "static/media/event-2.e5aab528.jpg";